import { createContext, useContext, useState, useCallback } from "react";

const ReactivateContext = createContext(null);

export const ReactivateProvider = ({ children }) => {
  const [target, setTarget] = useState(null); // { packageRef, featureKey }

  const openReactivate = useCallback((packageRef, featureKey = null) => {
    setTarget({ packageRef, featureKey });
  }, []);

  const closeReactivate = useCallback(() => {
    setTarget(null);
  }, []);

  return (
    <ReactivateContext.Provider value={{ target, openReactivate, closeReactivate }}>
      {children}
    </ReactivateContext.Provider>
  );
};

export const useReactivate = () => {
  const ctx = useContext(ReactivateContext);
  if (!ctx) return { target: null, openReactivate: () => {}, closeReactivate: () => {} };
  return ctx;
};
